/**
 * ISSUE-1168. The pure logic for the team profile Roster panel. The grouping is the provider's, stored by sports-api and printed verbatim, so this reuses the game detail Rosters tab's buildLineupSections with no starters. Unlike that tab it keeps the injured group: D2 lists every stored player, and the heading says which group a player is in.
 */
import type { typePlayerSearch } from "../../routeState/playerSearch";
import {
  buildLineupSections,
  type typeLineupPlayer,
  type typeLineupSection,
} from "../gameDetail/lineupTabLogic";

export const TEAM_ROSTER_FAILED_LINE = "We could not load this team's roster.";
export const TEAM_ROSTER_EMPTY_LINE =
  "This team's roster has not been published yet.";

export type typeTeamRosterTeam = {
  teamId: string;
  name: string;
  abbreviation: string;
};

export type typeTeamRosterGroupInput = {
  groupKey: string;
  label: string;
  players: readonly {
    playerId: string;
    name: string;
    jerseyNumber?: string | null;
    position?: string | null;
    headshotUrl?: string | null;
  }[];
};

/** Provider order, empty groups dropped, every group kept, injured included. */
export function toTeamRosterSections(
  groups: readonly typeTeamRosterGroupInput[],
): typeLineupSection[] {
  return buildLineupSections({ groups, starterPlayerIds: new Set<string>() });
}

/** The params LineupTab.tsx sends, so the player page reads the same fields. */
export function teamRosterPlayerSearch(input: {
  player: typeLineupPlayer;
  team: typeTeamRosterTeam;
}): typePlayerSearch {
  const { player, team } = input;
  return {
    playerId: player.playerId,
    name: player.name,
    teamId: team.teamId,
    teamName: team.name,
    teamAbbreviation: team.abbreviation,
    jerseyNumber: player.jerseyNumber ?? undefined,
    position: player.position ?? undefined,
  };
}
